module.exports = {"id":"199752","name":"Sylvester Igboun","rating":"75","photo":"./data/images/photos/2/199752.png","club":{"name":"FK Oufa","logo":"./data/images/clubs/FKOufa.png"},"positions":["BU","MG","MD","ATT"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SylvesterIgboun0.json
// module id = 4065
// module chunks = 0